
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OrderLineModel } from './Entities.GormCrm.OrderLine';
import { Model, ModelProperty } from 'models/Model';


export class OrderLineCommissionModel extends Model<OrderLineCommissionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'orderLineId', type: 'guid', languageString: 'orderLineCommission.property.orderLineId' },
		{ name: 'acvExtend', type: 'number', languageString: 'orderLineCommission.property.acvExtend' },
		{ name: 'acvIncrease', type: 'number', languageString: 'orderLineCommission.property.acvIncrease' },
		{ name: 'upFront', type: 'number', languageString: 'orderLineCommission.property.upFront' },
		{ name: 'oneOff', type: 'number', languageString: 'orderLineCommission.property.oneOff' },
		{ name: 'acvExtendCommissionEnabled', type: 'boolean', languageString: 'orderLineCommission.property.acvExtendCommissionEnabled' },
		{ name: 'acvIncreaseCommissionEnabled', type: 'boolean', languageString: 'orderLineCommission.property.acvIncreaseCommissionEnabled' },
		{ name: 'upFrontCommissionEnabled', type: 'boolean', languageString: 'orderLineCommission.property.upFrontCommissionEnabled' },
		{ name: 'oneOffCommissionEnabled', type: 'boolean', languageString: 'orderLineCommission.property.oneOffCommissionEnabled' },
		{ name: 'acvIncreasePartitions', type: 'number', languageString: 'orderLineCommission.property.acvIncreasePartitions' },
		{ name: 'orderLine', type: 'OrderLineModel', languageString: 'orderLineCommission.property.orderLine', isHidden: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } }
	];
	[key: string]: any;
	
	public orderLineId?: string;
	public acvExtend: number;
	public acvIncrease: number;
	public upFront: number;
	public oneOff: number;
	public acvExtendCommissionEnabled: boolean;
	public acvIncreaseCommissionEnabled: boolean;
	public upFrontCommissionEnabled: boolean;
	public oneOffCommissionEnabled: boolean;
	public acvIncreasePartitions?: number;
	public orderLine?: OrderLineModel;
    
	constructor(){
		super();
		this.orderLineId = undefined;
		this.acvExtend = 0;
		this.acvIncrease = 0;
		this.upFront = 0;
		this.oneOff = 0;
		this.acvExtendCommissionEnabled = false;
		this.acvIncreaseCommissionEnabled = false;
		this.upFrontCommissionEnabled = false;
		this.oneOffCommissionEnabled = false;
		this.acvIncreasePartitions = undefined;
		this.orderLine = undefined;
		
	}
	getProperties(){
		return OrderLineCommissionModel.classProperties;
	}
}

